import styled, { css } from 'styled-components';

export const ConfigurationGatorClaw = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: ${theme.v3.colors.neutral[100]};
    border-radius: ${theme.v3.border.radius.xl};
    font-family: ${theme.v3.font.family.brand};
    padding: 48px 24px;
    height: 100%;
    flex-grow: 1;
  `}
`;

export const Wrapper = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
    max-width: 512px;
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${(theme.v3.spacing && theme.v3.spacing.xxxs) || '16px'};
  `}
`;

export const LogoWrapper = styled.div`
  ${() => css`
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    text-align: center;
    margin: 0;
  `}
`;

export const Content = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    width: 100%;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    text-align: center;
    margin: 0;
    width: 100%;
  `}
`;

export const TermsAlert = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 8px;
    align-items: center;
    width: 100%;
    padding: 16px;
    background: ${(theme.v3.colors && theme.v3.colors.brand && theme.v3.colors.brand['ultra-light']) || '#f3f9ff'};
    border-left: 4px solid ${(theme.v3.colors && theme.v3.colors.brand && theme.v3.colors.brand.pure) || '#2e93ee'};
    border-radius: ${(theme.v3.border && theme.v3.border.radius && theme.v3.border.radius.none) != null ? theme.v3.border.radius.none : '4px'};
  `}
`;

export const TermsText = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: 14px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
    flex: 1;
  `}
`;

export const TermsLink = styled.a`
  ${({ theme }) => css`
    color: ${(theme.v3.colors && theme.v3.colors.brand && theme.v3.colors.brand['snappy-blue'] && theme.v3.colors.brand['snappy-blue'][50]) || '#007acf'};
    text-decoration: underline;
    font-weight: ${theme.v3.font.weights.medium};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  `}
`;

export const Actions = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;

    svg {
      fill: none!important;
      path {
        fill: none!important;
        stroke-width: 4!important;
      }
    }
  `}
`;
